export default {
  answerButton: 'Reply',
  breadCrumbMessages: 'My messages',
  deleteMessage: 'Delete message',
  title: 'Email detail',
  object: 'Topic:',
  lob: 'Line of business:',
  contract: 'Contract:',
  recipient: 'Recipient:',
  anotherRecipient: 'Another recipient:',
  receivedDate: 'Received:',
  expirationDate: 'Expiration date:',
  sentDate: 'Sent: ',
  number: 'No.',
  buttonDelete: 'Delete message',
  messageDeleteSnackbar: 'Message deleted.',
  cancelButton: 'Cancel',
  sendAnswerButton: 'Reply',
  messageAnswerSnackbar: 'Answer sent ({{msgId}})',
};
